import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import List from "@material-ui/core/List";
import withStyles from "@material-ui/core/styles/withStyles";
import SearchIcon from "@material-ui/icons/Search";
import classNames from "classnames";
import { detect } from "detect-browser";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import cancelIcon from "../../Assets/Svg/cancel_black.svg";
import { instance } from "../../Actions/AxiosInstance";
import { RightDrawer } from "../../Actions/commonAction";
import EmpProfile from "../../Assets/Images/defaultEmp.svg";
import createstore from "../../store";
// import { black } from 'material-ui/styles/colors';
// import If from "../../../../Component/Common/If";
import If from "../Common/If";
import "./index.style.css";
import { getFormattedImageLink } from "../../Utils";

const drawerWidth = 540;
const browser = detect();

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: "30%",
    overflowY: "hidden",
    //  marginRight: 40,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    // padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  rightMargin: {
    right: 64,
  },
});

class HelperTextMainDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      List: [],
      EmpList: [],
      tempList: [],
      page: 0,
      rowsPerPage: 10,
      offset: 0,
      drawerType: "",
      fullcount: "",
      right: false,
      configid: "",
      subdomain: "",
      systemdetail: "Windows 8 64",
      browserdetail: browser.name,
      logintype: 1,
      port: window.location.port,
      empid: "",
      histrptid: "",
      rptid: "",
    };

    this.viewmore = this.viewmore.bind(this);
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const drawerType = this.props.DrawerReducer.drawerdata;
    const { open } = this.props.DrawerReducer;
    const right = this.props.DrawerReducer.side;
    const { empid } = this.props.DrawerReducer;
    const { rptid } = this.props.DrawerReducer;
    const { histrptid } = this.props.DrawerReducer;
    this.setState(
      {
        drawerType,
        open,
        right,
        empid,
        rptid,
        histrptid,
      },
      () => {
        this.GetData();
      },
    );

    this.setState({
      List,
      tempList: this.state.EmpList,
      drawerType,
      empid,
    });
  }

  componentDidMount() {}

  viewmore() {
    this.setState({ offset: this.state.offset + 10 }, () => {
      this.GetData();
    });
  }

  renderSwitch(type) {
    switch (type) {
      case "designation":
        this.setState({
          configid: this.props.DrawerReducer.configid.designationid,
        });
        break;
      case "team":
        this.setState({ configid: this.props.DrawerReducer.configid.teamid });
        break;
      case "department":
        this.setState({
          configid: this.props.DrawerReducer.configid.departmentid,
        });
        break;
      case "grade":
        this.setState({
          configid: this.props.DrawerReducer.configid.designationid,
        });
        break;
      case "Business Unit":
        this.setState({
          configid: this.props.DrawerReducer.configid.subscriptiongradeid,
        });
        break;
      default:
        break;
    }
  }

  // componentWillReceiveProps(props) {
  //   this.setState(
  //     {
  //       open: props.DrawerReducer.open,
  //       drawerType: props.DrawerReducer.drawerdata,
  //       right: props.DrawerReducer.side,
  //     },
  //     () => {
  //       this.GetData();
  //     },
  //   );
  // }

  componentWillReceiveProps(props) {
    if (
      props.DrawerReducer.rptid != this.props.rptid ||
      props.DrawerReducer.histrptid != this.props.histrptid ||
      props.DrawerReducer.empid != this.props.empid
    ) {
      this.props = props;
      const drawerType = this.props.DrawerReducer.drawerdata;
      const { open } = this.props.DrawerReducer;
      const right = this.props.DrawerReducer.side;
      const { empid } = this.props.DrawerReducer;
      const { rptid } = this.props.DrawerReducer;
      const { histrptid } = this.props.DrawerReducer;
      this.setState(
        {
          drawerType,
          open,
          right,
          empid,
          rptid,
          histrptid,
          page: 0,
          rowsPerPage: 10,
          offset: 0,
          fullcount: "",
          EmpList: [],
        },
        () => {
          // this.toggleDrawer(right, open);
          this.GetData();
        },
      );
    }
  }

  GetData() {
    const type = this.state.drawerType;
    console.log("type: ", type);
    // this.renderSwitch(type);
    const id = this.props.location.pathname.split("/");
    if (this.state.drawerType == "Profileteam") {
      const data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: !isNaN(id[2]) ? id[2] : this.props.login.employeeid,
        limit: this.state.rowsPerPage,
        offset: this.state.offset,
      };
      instance
        .post("/employee/getempteamemployee", data)
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Profilemanager") {
      instance
        .get(
          `/subscription/getempolyeemanager/${this.state.empid}/${3}/${
            this.state.offset
          }/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "designation") {
      const desigid = this.props.DrawerReducer.configid.designationid;
      instance
        .get(
          `/subscription/employeeswithdesignation/${desigid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "department") {
      const depid = this.props.DrawerReducer.configid.departmentid;
      instance
        .get(
          `/subscription/employeeswithdepartment/${this.props.DrawerReducer.configid.departmentid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Business Unit") {
      const depid = this.props.DrawerReducer.configid.businessunitid;
      instance
        .get(
          `/subscription/employeeswithbusinessunit/${this.props.DrawerReducer.configid.businessunitid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "grade") {
      const depid = this.props.DrawerReducer.configid.subscriptiongradeid;
      instance
        .get(
          `/subscription/employeeswithgrade/${this.props.DrawerReducer.configid.subscriptiongradeid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "team") {
      const depid = this.props.DrawerReducer.configid.subscriptiongradeid;
      instance
        .get(
          `/subscription/employeeswithteam/${this.props.DrawerReducer.configid.teamid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "probation plan") {
      // let probationperiodid = this.props.DrawerReducer.configid.probationperiodid;
      instance
        .get(
          `/subscription/assignedempprobperiod/${this.props.DrawerReducer.configid.probationperiodid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "ScheduledUserReport") {
      instance
        .post("/reportrobo/reportsentemp", {
          id: this.state.rptid,
          ishistory: false,
          offset: this.state.offset,
          limit: this.state.rowsPerPage,
        })
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "workFlow") {
      const workflowid = this.props.DrawerReducer.configid;

      instance
        .get(
          `/subscription/assignedapprovalworkflowpolicy/${workflowid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "HistoryUserReport") {
      instance
        .post("/reportrobo/reportsentemp", {
          id: this.state.histrptid,
          ishistory: true,
          offset: this.state.offset,
          limit: this.state.rowsPerPage,
        })
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Attendence policie") {
      const { attendancepolicyid } = this.props.DrawerReducer.configid;
      instance
        .get(
          `attendance/assignedemployee/${attendancepolicyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Extra Time") {
      const { extratimepolicyid } = this.props.DrawerReducer.configid;
      instance
        .get(
          `attendance/assignedempextratimepolicy/${extratimepolicyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Holiday Plan") {
      const { holidayplanid } = this.props.DrawerReducer.configid;
      const { holidayyear } = this.props.DrawerReducer;
      instance
        .post(`/leaves/assignedempwithholidayplan/${holidayplanid}`, {
          holidayyear,
          offset: this.state.offset,
          limit: this.state.rowsPerPage,
        })
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Clock-in Method") {
      const { devicepolicyid } = this.props.DrawerReducer.configid;
      console.log("devicepolicyid: ", devicepolicyid);
      instance
        .get(
          `/attendance/getassignedemployee/${devicepolicyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Shift") {
      const { shiftid } = this.props.DrawerReducer.configid;

      instance
        .get(
          `/attendance/getassignedemployeeshift/${shiftid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Leaves policie") {
      const { leavepolicy } = this.props.DrawerReducer.row.leavepolicy;
      console.log("leavepolicy: ", leavepolicy);
      const data = {
        leavepolicyid: this.props.DrawerReducer.row.leavepolicy,
        offset: this.state.offset,
        limit: this.state.rowsPerPage,
      };
      instance
        .post("/leaves/assignedempwithleavepolicy", data)
        .then((result) => {
          // instance
          //   .get(
          //     `/leaves/assignedempwithleavepolicy/${leavepolicy}/${this.state.offset}/${this.state.rowsPerPage}`,
          //   )
          //   .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Weekly off") {
      console.log("here12");
      const { weekoffpolicyid } = this.props.DrawerReducer.row;

      instance
        .get(
          `/subscription/assigenedempweekoffpolicy/${weekoffpolicyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "permissionpolicy") {
      const profileid = this.props.DrawerReducer.configid;
      instance
        .get(
          `subscription/employeewithpermissionprofile/${profileid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Biometric") {
      const biometricdeviceid = this.props.DrawerReducer.configid;
      const data = {
        biometricdeviceids: [biometricdeviceid],
        offset: this.state.offset,
        limit: this.state.rowsPerPage,
      };
      instance
        .post("/biometric/assignedemployeeswithdevice", data)
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "expense policie") {
      const policyid = this.props.DrawerReducer.configid;
      instance
        .get(
          `/expense/assignedemployee/${policyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "signatories-recepients") {
      const letterid = this.props.DrawerReducer.configid;
      instance
        .get(
          `/letter/getletterrecepient/${letterid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);

          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "checklist") {
      const { checklistid } = this.props.DrawerReducer.configid;
      console.log(this.props.DrawerReducer.configid);
      instance
        .get(`checklist/getEmployees`, {
          params: {
            checklistid,
            offset: this.state.offset,
            limit: this.state.rowsPerPage,
          },
        })
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Salary structure") {
      instance
        .get(
          `payroll/getstructureassignedemployee/${this.props.DrawerReducer.row.salarystructureid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Payroll tag") {
      instance
        .get(
          `payroll/payrollcustomtagassignemplist/${this.props.DrawerReducer.row.payrollcustomtagid}/${this.state.rowsPerPage}/${this.state.offset}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "flexible plan") {
      instance
        .get(
          `payroll/getfbpassignemployeelist/${this.props.DrawerReducer.row.subscriptionfbpid}/${this.state.rowsPerPage}/${this.state.offset}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "reviewform") {
      instance
        .get(
          `perform/getreviewformassignment/${this.props.DrawerReducer.row.reviewformid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "Exit policies") {
      instance
        .get(
          `exit/getexitpolicyemployeelist/${this.props.DrawerReducer.row.exitpolicyid}/${this.state.offset}/${this.state.rowsPerPage}`,
        )
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "360review") {
      console.log(
        "this.props.DrawerReduce: ",
        this.props.DrawerReducer.configid,
      );
      const data = {
        reviewstructureid: this.props.DrawerReducer.configid.reviewstructureid,
        employeeid: this.props.DrawerReducer.configid.employeeid,
        offset: this.state.offset,
        limit: this.state.rowsPerPage,
        empreviewformid: this.props.DrawerReducer.configid.empreviewformid,
      };
      instance
        .post(`perform/getformparticipant`, data)
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "FnF Policie") {
      const data = {
        offset: this.state.offset,
        limit: this.state.rowsPerPage,
        fnfpolicyid: this.props.DrawerReducer.row.fnfpolicyid,
      };
      instance
        .post(`payroll/getfnfassignemplist`, data)
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.drawerType == "hiringplan") {
      const data = {
        offset: this.state.offset,
        limit: this.state.rowsPerPage,
        hiringplanid: this.props.DrawerReducer.row.hiringplanid,
        // partnertypeid: this.props.DrawerReducer.row.partnertypeid,
        partnertypeid: 2,
      };
      instance
        .post(`recruit/getassignhiringpatner`, data)
        .then((result) => {
          let EmpList = [];
          const fullcount =
            result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
          result.data.result.length > 0
            ? (EmpList = [...this.state.EmpList, ...result.data.result])
            : (EmpList = this.state.EmpList);
          this.setState({ EmpList, fullcount, tempList: EmpList });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  handleChange(e) {
    const EmpList = this.state.tempList.filter(
      (item) =>
        (item.employeename || item.fullname)
          .toLowerCase()
          .search(e.target.value.toLowerCase()) !== -1,
    );

    this.setState({ EmpList });
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
    this.props.RightDrawer({
      drawerdata: "",
      configid: [],
      open: "",
      side: false,
    });
  };

  routeDirectory(e) {
    this.setState({
      EmpList: [],
      page: 0,
      rowsPerPage: 5,
      offset: 0,
      drawerType: "",
      fullcount: "",
      histrptid: "",
      rptid: "",
    });

    const employeeLink = `${window.location.origin}/subscription/directory`;

    this.props.RightDrawer({
      drawerdata: "",
      configid: [],
      open: "",
      side: false,
    });

    setTimeout(() => {
      window.open(employeeLink, "_blank");
    }, 100);
  }

  routeProfile(id, e) {
    const employeeLink = `${window.location.origin}/profile/${id}`;

    this.props.RightDrawer({
      drawerdata: "",
      configid: [],
      open: "",
      side: false,
    });
    setTimeout(() => {
      window.open(employeeLink, "_blank");
    }, 100);
  }

  handleDrawerClose = () => {
    this.setState((state) => ({ open: !state.open }));
    this.GetData();
  };

  render() {
    const { classes, theme, DrawerReducer } = this.props;

    const { open } = this.state;

    return (
      <div className={classes.root}>
        <Drawer
          className={`${classes.drawer} superuser-drawer`}
          anchor="right"
          open={this.state.right}
          // onClick={this.toggleDrawer("right", false)}
          // onClick={() =>this.toggleDrawer('right', false)}
          onClose={() => this.toggleDrawer("right", false)}
          // onClose={() => this.setState({ right: false })}
          // onOpen={() => this.toggleDrawer('right', true)}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Grid item xs={12} md={12} sm={12}>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <div className="padding10 cursurpointer">
                  <span
                    className="drawer-close-btn"
                    onClick={this.toggleDrawer("right", false)}
                    // onClick={() => this.setState({ right: false })}
                  >
                    {/* <svg onClick={this.toggleDrawer("right", false)} width="24" height="24" viewBox="0 0 24 24">
                      <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                    </svg> */}
                    <img
                      src={cancelIcon}
                      onClick={this.toggleDrawer("right", false)}
                    ></img>
                  </span>

                  {/* <span onClick={this.routeDirectory.bind(this)} className={classNames("cursour-pointer")}>
                    <div className="inlineClass padding-left-10" >View All</div>
                  </span> */}
                  <div
                    className="inlineClass margin-left-8 position-rel"
                    style={{ top: -2 }}
                  >
                    <div className={classNames(classes.search, "width100")}>
                      <div className={classes.searchIcon}>
                        <SearchIcon className="icon-se" />
                      </div>
                      <Input
                        placeholder="Search"
                        disableUnderline
                        fullWidth
                        className="master-search"
                        style={{ color: "black !important" }}
                        onChange={this.handleChange.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Divider />
            <div
              className="list-scrollable thin-scroll"
              onScroll={this.loadMoreItems}
            >
              <Grid container>
                <Grid item xs={12} md={12} sm={12}>
                  {/* {this.state.loadingState ? <p className="loading"> loading More Items..</p> : ""} */}
                  <React.Fragment>
                    {this.state.EmpList.map((listdata) => (
                      <React.Fragment key="key">
                        <Grid container className="employee-list-drawer">
                          <Grid item xs={12} md={12} sm={12}>
                            <div className="position-rel">
                              <div
                                onClick={this.routeProfile.bind(
                                  this,
                                  listdata.employeeid,
                                )}
                                className={classNames(
                                  "cursour-pointer width100",
                                )}
                              >
                                <div className="floatleft">
                                  {listdata.imagepath ? (
                                    <img
                                      className="dir-profile-img margin-top-3"
                                      src={getFormattedImageLink(
                                        listdata.imagepath,
                                      )}
                                      height="83"
                                    />
                                  ) : (
                                    <img
                                      className="dir-profile-img margin-top-3"
                                      src={EmpProfile}
                                      height="83"
                                    />
                                  )}
                                </div>

                                <div className="request-empprofile-info">
                                  <div className="request-empprofile-info-content">
                                    <p className="no-padding nomargin req-message-head-rightDrawer">
                                      {listdata.employeename ||
                                        listdata.fullname}
                                    </p>
                                    <If condition={listdata.designationname}>
                                      <p
                                        className="no-padding req-message-cont"
                                        style={{ margin: "12px 0px 4px 0px" }}
                                      >
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            style={{
                                              width: 16,
                                              position: "relative",
                                              top: 3,
                                            }}
                                          >
                                            <path
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                                          </svg>
                                        </span>
                                        <span>
                                          {" "}
                                          {listdata.designationname}{" "}
                                        </span>
                                      </p>
                                    </If>
                                    <div align="left">
                                      <span className="margin-top-10 ">
                                        <span style={{ height: 22, width: 22 }}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            style={{
                                              position: "relative",
                                              top: 4,
                                              left: 0,
                                              width: 16,
                                              height: 16,
                                              background: "transaparent",
                                            }}
                                          >
                                            <path
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                          </svg>
                                        </span>
                                        <CopyToClipboard
                                          text={this.state.copyText}
                                        >
                                          <span
                                            className="t-14"
                                            onClick={() =>
                                              this.setState({
                                                copyText: listdata.displaymbl,
                                                copied: true,
                                              })
                                            }
                                          >
                                            {listdata.primarymobile}
                                          </span>
                                        </CopyToClipboard>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                  {/* {this.state.EmpList.length < this.state.fullcount
                    && <React.Fragment>
                      <Button onClick={this.viewmore} className="viewmore-btn">
                        Load More
                    </Button>
                    </React.Fragment>} */}

                  {this.state.EmpList.length < this.state.fullcount &&
                  this.state.EmpList.length == this.state.tempList.length ? (
                    <Button onClick={this.viewmore} className="viewmore-btn">
                      Load More
                    </Button>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Drawer>
      </div>
    );
  }
}

HelperTextMainDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  login: state.AuthenticationAction.login,
  DrawerReducer: state.DrawerReducer,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles, { withTheme: true })(
    withRouter(withSnackbar(HelperTextMainDrawer)),
  ),
);
